export function useFormat2 ( input ) {
	return computed( () => {
		const lines = Array.isArray( input )
			? input
			: typeof input === 'string'
				? input.split( /\r?\n/ )
				: [];

		const result = [];

		lines.forEach( ( line, lineIndex ) => {
			// 檢查是否包含 HTML 標籤
			const containsHtml = typeof line === 'string' && /<[a-z][\s\S]*>/i.test( line );

			if ( typeof line === 'string' && line.includes( '<br' ) ) {
				// 使用正則表達式找出所有 br 標籤
				// 使用非捕獲組 (?:) 避免額外的分組
				const brRegex = /<br\s*(?:class=['"]([^'"]*)['"]\s*)?\/?>|<br\s*(?:class=['"]([^'"]*)['"]\s*)?>/gi;

				let lastIndex = 0;
				let match;

				// 使用 exec 方法逐個查找 br 標籤
				while ( ( match = brRegex.exec( line ) ) !== null ) {
					// 添加 br 標籤前的文本
					const beforeText = line.substring( lastIndex, match.index );
					if ( beforeText ) {
						result.push( {
							text: beforeText,
							isLineBreak: false,
							isHtml: /<[a-z][\s\S]*>/i.test( beforeText )
						} );
					}

					// 獲取類名 (可能在第一個或第二個捕獲組中)
					const brClass = match[ 1 ] || match[ 2 ] || '';

					// 添加換行
					result.push( {
						text: '',
						isLineBreak: true,
						brClass: brClass,
						isHtml: false
					} );

					lastIndex = brRegex.lastIndex;
				}

				// 添加最後一個 br 標籤後的文本
				const afterText = line.substring( lastIndex );
				if ( afterText ) {
					result.push( {
						text: afterText,
						isLineBreak: false,
						isHtml: /<[a-z][\s\S]*>/i.test( afterText )
					} );
				}
			} else {
				result.push( {
					text: line,
					isLineBreak: false,
					isHtml: containsHtml
				} );
			}

			// 加上換行（非最後一行才加）
			if ( lineIndex < lines.length - 1 ) {
				result.push( {
					text: '',
					lang: null,
					isLineBreak: true
				} );
			}
		} );

		return result;
	} );
}


